const DEFAULT_DISCORD_AVATAR = "https://cdn.discordapp.com/embed/avatars/0.png";

export function getDiscordAvatarUrl(user) {
    if (!user) return DEFAULT_DISCORD_AVATAR;
    
    // If the avatar is a full URL, return it
    if (user.avatar?.startsWith('http')) {
        return user.avatar;
    }
    
    // If there's an avatar hash, construct the CDN URL
    if (user.avatar) {
        const extension = user.avatar.startsWith('a_') ? 'gif' : 'png';
        const userId = user.userId || user.id || user.discord_id;
        if (userId) {
            return `https://cdn.discordapp.com/avatars/${userId}/${user.avatar}.${extension}?size=128`;
        }
    }
    
    // If no avatar, return default avatar based on user discriminator or a fallback
    const defaultIndex = user.discriminator ? (parseInt(user.discriminator) % 5) : 0;
    return `https://cdn.discordapp.com/embed/avatars/${defaultIndex}.png`;
}
